import { Directive, TemplateRef, ViewContainerRef, inject } from '@angular/core';

@Directive({
    selector: '[blackModalContent]',
    standalone: false
})
export class ModalContentDirective {
  templateRef = inject<TemplateRef<any>>(TemplateRef);
  viewContainerRef = inject(ViewContainerRef);


  showContent(){
    this.viewContainerRef.createEmbeddedView(this.templateRef);
  }

}
